import OnlyHeader from "components/Headers/OnlyHeader";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import firebase from "../config/firebase";
import { getSportContest } from "store/actions/athletesAction";
import { suggestAthlete } from "store/actions/athletesAction";
import { getSuggestAthleteById } from "store/actions/athletesAction";
import contestImg from "../assets/img/custom/contestImg.jpg";
const AthleteIdsForContest = () => {
  let dispatch = useDispatch();
  const { contestData, rejectedSuggestedUsers, suggestedAthletes } =
    useSelector((state) => state.athletes);
  console.log(rejectedSuggestedUsers);
  const { uid, user } = useSelector((state) => state.auth);
  const [suggestionModal, setSuggestionModal] = useState(false);
  const [contestId, setContestId] = useState("");
  const [result, setResult] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [haveAllReadyData, setHaveAllReadyData] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [tasks, setTasks] = useState([{ athleteId: "", reason: "" }]);
  console.log(tasks);
  const handleAddTask = () => {
    const lastTask = tasks[tasks.length - 1];

    if (!lastTask.athleteId || !lastTask.reason.trim()) {
      toast.error("Please fill out both fields");
      return;
    }

    if (lastTask.athleteId < 1000180) {
      toast.warning("Athlete ID must be big then 1000180.");
      return;
    }

    const athleteIdExists = tasks.some(
      (task, index) =>
        task.athleteId === lastTask.athleteId && index !== tasks.length - 1
    );

    if (athleteIdExists) {
      toast.error("Athlete ID already exists.");
      return;
    }

    setTasks([...tasks, { athleteId: "", reason: "" }]);
  };
  const handleTaskChange = (index, field, value) => {
    const newTasks = [...tasks];
    newTasks[index][field] = value;
    setTasks(newTasks);
  };

  const handleRemoveTask = (index) => {
    const newTasks = [...tasks];
    newTasks.splice(index, 1);
    setTasks(newTasks);
  };
  const toggleModal = () => {
    setSuggestionModal(!suggestionModal);
    setResult(false);
    setTasks([{ athleteId: "", reason: "" }]);
  };
  const isDuplicateAthleteId = (athleteId, currentIndex) => {
    return tasks.some(
      (task, index) => task.athleteId === athleteId && index !== currentIndex
    );
  };
  console.log("contestData===>", contestData);
  useEffect(() => {
    setDataLoader(true);
    dispatch(
      getSportContest(() => {
        setDataLoader(false);
      })
    );
  }, []);

  const handleSubmit = () => {
    let hasError = false;
    let duplicateIdError = "";
    let emptyFieldError = "";

    const athleteIds = tasks.map((task) => task.athleteId);
    const duplicates = athleteIds.filter(
      (id, index) => athleteIds.indexOf(id) !== index
    );

    if (duplicates.length > 0) {
      duplicateIdError = "There are duplicate Athlete IDs.";
      hasError = true;
    }

    tasks.forEach((task) => {
      if (!task.athleteId || !task.reason.trim()) {
        emptyFieldError = "Athlete ID and Reason cannot be empty.";
        hasError = true;
      }
      if (task.athleteId < 1000180) {
        emptyFieldError = "Athlete ID Must Be Big Then 1000180.";
        hasError = true;
      }
    });

    if (hasError) {
      if (duplicateIdError) {
        toast.error(duplicateIdError);
      }
      if (emptyFieldError) {
        toast.error(emptyFieldError);
      }
    } else {
      let data = {
        athleteData: tasks,
        collectionId: contestId,
        coachId: uid,
        created_at: firebase.firestore.Timestamp.now(),
        coach_data: user,
      };
      setBtnLoader(true);
      dispatch(
        suggestAthlete(data, (res) => {
          setBtnLoader(false);
          if (res == "success") {
            setResult(true);
          }
        })
      );
    }
  };

  const handleAddAthletes = (id) => {
    let data = {
      collectionId: id,
      uid: uid,
    };
    setModalLoader(true);
    toggleModal();
    dispatch(
      getSuggestAthleteById(data, (res) => {
        if (res == "empty") {
          setHaveAllReadyData(false);
          setContestId(id);
          setModalLoader(false);
        }
        if (res == "data") {
          setHaveAllReadyData(true);
          setContestId(id);
          setModalLoader(false);
        }
      })
    );
  };

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <h2>
          Your football team starters are those players on your offense who were
          on the field for your team’s first play on offense from scrimmage in
          the semi-final game, and those players on your defense who were on the
          field for your team’s first play on defense from scrimmage in the
          semi-final game. Therefore, your team will submit, after the
          semi-final game, the FHP ID#s of UP TO 22 players. This means that for
          the 4 teams in the two semi-final games, there will be submitted a
          total of 88 FHP ID#s, assuming all 88 starters are each registered at
          FHP.{" "}
        </h2>
        <img src={contestImg} alt="" width="100%" className="mb-3" />
        <Row>
          <div className="col">
            <Card className="shadow mb-4">
              <CardHeader className="border-0 d-flex align-items-center">
                <h3 className="mb-0">Suggest Athletes For Contest</h3>
              </CardHeader>
              {dataLoader ? (
                <div className="text-center my-4">
                  <Spinner color="primary" />
                </div>
              ) : (
                <>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Contest Id
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Sport Name
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          FF Season
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Start Date
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          End Date
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Created At
                        </th>
                        <th
                          scope="col"
                          className="custom-table-heading custom-heading"
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {contestData.length > 0 ? (
                        contestData.map((contest, index) => {
                          return (
                            <tr key={index}>
                              <td className={`custom-table-text `}>
                                {contest.contestId
                                  ? contest.contestId
                                  : "old Contest"}
                              </td>
                              <td className={`custom-table-text `}>
                                {contest.sportName}
                              </td>

                              <td className="custom-table-text">
                                {contest.ffSeason}
                              </td>
                              <td className="custom-table-text">
                                {moment
                                  .unix(contest?.startDate?.seconds)
                                  .format("DD-MM-YYYY")}
                              </td>
                              <td className="custom-table-text">
                                {moment
                                  .unix(contest?.endDate?.seconds)
                                  .format("DD-MM-YYYY")}
                              </td>
                              <td className="custom-table-text">
                                {moment
                                  .unix(contest?.createdAt?.seconds)
                                  .format("DD-MM-YYYY")}
                              </td>
                              <td
                                className={`card-subtitle  
                                  
                                `}
                              >
                                <Button
                                  color="primary"
                                  size="sm"
                                  onClick={() => handleAddAthletes(contest.id)}
                                >
                                  Add Athletes
                                </Button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </>
              )}
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={suggestionModal} centered toggle={toggleModal} size="lg">
        {modalLoader ? (
          <div className="text-center my-4">
            <Spinner color="primary" />
          </div>
        ) : (
          <ModalBody>
            {haveAllReadyData ? (
              <>
                <h2 className="text-center">All Ready Add Athlete</h2>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th
                        scope="col"
                        className="custom-table-heading custom-heading"
                      >
                        Athlete Id
                      </th>
                      <th
                        scope="col"
                        className="custom-table-heading custom-heading"
                      >
                        Reason
                      </th>
                      <th
                        scope="col"
                        className="custom-table-heading custom-heading"
                      >
                        Created At
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {suggestedAthletes.map((items, index) => {
                      return (
                        <tr key={index}>
                          <td>{items.athlete_id}</td>
                          <td>{items.reason}</td>
                          <td>
                            {moment
                              .unix(items?.created_at?.seconds)
                              .format("DD-MM-YYYY")}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </>
            ) : (
              <div>
                {tasks.map((items, index) => {
                  return (
                    <Row key={index}>
                      <Col sm="4">
                        <Label>Add Athlete Id</Label>
                        <Input
                          type="number"
                          placeholder="Enter Athlete Id"
                          invalid={isDuplicateAthleteId(items.athleteId, index)}
                          value={items.athleteId}
                          onChange={(e) =>
                            handleTaskChange(
                              index,
                              "athleteId",
                              Number(e.target.value)
                            )
                          }
                        />
                      </Col>
                      <Col sm="5">
                        <Label>Reason</Label>
                        <Input
                          placeholder="Enter Reason "
                          value={items.reason}
                          onChange={(e) =>
                            handleTaskChange(index, "reason", e.target.value)
                          }
                        />
                      </Col>
                      <Col sm="3" className="d-flex align-items-end">
                        <Button color="primary" onClick={handleAddTask}>
                          +
                        </Button>
                        {index > 0 && (
                          <Button
                            color="primary"
                            onClick={() => handleRemoveTask(index)}
                          >
                            -
                          </Button>
                        )}
                      </Col>
                    </Row>
                  );
                })}
              </div>
            )}
            {result && (
              <div className="mt-4">
                {rejectedSuggestedUsers.length > 0 ? (
                  <>
                    <h2 className="text-center">Rejected Athletes</h2>
                    <Table
                      className="align-items-center table-flush"
                      responsive
                    >
                      <thead className="thead-light">
                        <tr>
                          <th
                            scope="col"
                            className="custom-table-heading custom-heading"
                          >
                            Athlete Id
                          </th>
                          <th
                            scope="col"
                            className="custom-table-heading custom-heading"
                          >
                            Reason
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {rejectedSuggestedUsers.map((items, index) => {
                          return (
                            <tr key={index}>
                              <td>{items.athleteId}</td>
                              <td>{items.reason}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </>
                ) : (
                  <h2 className="text-center">Add Athletes Successfully</h2>
                )}
              </div>
            )}
            <div className="text-right mt-4">
              <Button
                size="sm"
                className="ml-2"
                color="danger"
                disabled={btnLoader}
                onClick={() => {
                  toggleModal();
                }}
              >
                Close
              </Button>
              {!result && (
                <Button
                  color="primary"
                  size="sm"
                  onClick={handleSubmit}
                  disabled={
                    btnLoader ||
                    tasks.some((task) => !task.athleteId || !task.reason.trim())
                  }
                >
                  {btnLoader ? <Spinner size="sm" /> : "Submit"}
                </Button>
              )}
            </div>
          </ModalBody>
        )}
      </Modal>
    </>
  );
};

export default AthleteIdsForContest;
